function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { getWordCount, getCharCount } from 'rubriq/helpers/richTextWordCount';
import { RUBRIQ_ABSTRACT_TEMPLATE_ELEMENT_ICONS, RUBRIQ_ABSTRACT_TEMPLATE_QUESTION_DETAILS } from '../../constants';
import RichTextEditor from './editor/RichTextEditor';
var RubriqTemplateResponseItem = function RubriqTemplateResponseItem(_ref) {
  var questionText = _ref.questionText,
    element = _ref.element,
    initialEditorState = _ref.initialEditorState,
    handleChange = _ref.handleChange,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    saved = _ref.saved,
    useCharacters = _ref.useCharacters;
  var _useState = useState(isExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var wordOrChar = useCharacters ? getCharCount(initialEditorState) : getWordCount(initialEditorState);
  // TODO stop hardcoding which categories are optional?
  var isOptional = (element !== null && element !== void 0 ? element : RUBRIQ_ABSTRACT_TEMPLATE_QUESTION_DETAILS[questionText].element) === 'Implications';
  var onResponseChange = function onResponseChange(editorState) {
    handleChange(questionText, editorState);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom rubriq-abstract-template-response-item"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "rounded-3 d-flex justify-content-between align-items-center py-3 px-2 gap-2 gap-sm-0 w-100",
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-3 align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-circle p-2 d-flex align-items-center justify-content-center rubriq-abstract-template-response-item-icon-wrapper"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid ".concat(RUBRIQ_ABSTRACT_TEMPLATE_ELEMENT_ICONS[element !== null && element !== void 0 ? element : RUBRIQ_ABSTRACT_TEMPLATE_QUESTION_DETAILS[questionText].element])
  })), /*#__PURE__*/React.createElement("p", {
    className: "p-0 m-0 fw-semibold"
  }, element !== null && element !== void 0 ? element : RUBRIQ_ABSTRACT_TEMPLATE_QUESTION_DETAILS[questionText].element, ' ', isOptional && "(optional)")), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: expanded ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down',
    className: "rubriq-abstract-template-response-item-expand-icon rounded-circle p-2"
  })), expanded && /*#__PURE__*/React.createElement("div", {
    className: "pt-2 pb-4 px-2 px-sm-0 d-flex w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column p-0 pe-sm-4 ps-sm-2 gap-2 w-100"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "m-0 fw-semibold"
  }, questionText), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '250px'
    }
  }, /*#__PURE__*/React.createElement(RichTextEditor, {
    onChange: onResponseChange,
    initialState: initialEditorState
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end align-items-center text-secondary gap-1"
  }, saved && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-check"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2"
  }, saved && /*#__PURE__*/React.createElement("span", null, "Saved"), /*#__PURE__*/React.createElement("span", null, wordOrChar, " ", useCharacters ? 'character' : 'word', wordOrChar !== 1 && 's')))), /*#__PURE__*/React.createElement("div", null)));
};
export default RubriqTemplateResponseItem;